import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { UtilService } from 'src/app/services/util.service';
import { localStorageKeys } from '../const/enum';

@Injectable({
  providedIn: 'root'
})
export class GuestGuard {
  constructor(
    private router: Router,
    private utils: UtilService,
  ) {
  }

  canActivate(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    if (this.utils.getLocalStorage(localStorageKeys.accessToken)) {
      this.router.navigate(['/new-dashboard']);
      return false;
    }
    return true;
  }
}
